export enum FuelReportApprovalAction {
    SUBMIT = 'submit',
    BOSS_APPROVAL = 'boss-approve',
    RETURN_TO_SUBMITTER = 'return-to-submitter',
    DECLINE = 'decline',
    SIGN = 'sign',
    SET_CHECKED_DATE = 'set-checked-date',
    CHANGE_ACCEPTING_PERFORMER = 'change-accepting-performer',
    EDIT = 'edit',
}
